export const getFirebaseAuthenticated = state => {
  return state.firebaseAuthenticated;
};
export const getAuthRedirect = state => {
  return state.authRedirect;
};
